module.exports = __webpack_public_path__ + "img/map-marker.cc692ce2.svg";